import {
  Container,
  Row,
  Col,
  Button,
  Stack
} from '@leroy-merlin-br/backyard-react-ui'

import { Icon } from 'lmcv/components/Icon'

import * as S from './styled'

const ModalContentError = ({ text, title, onClose }) => (
  <S.ContentWrapper>
    <Stack align="center" spacing="giga">
      <Icon name="bricks" fill="currentColor" />

      <S.ModalTitle size="giga">{title}</S.ModalTitle>

      <S.ModalText size="kilo">{text}</S.ModalText>
    </Stack>

    <Container>
      <Row justify="center">
        <Col size={{ giga: 2 }}>
          <Button type="button" color="green" onClick={onClose}>
            ok
          </Button>
        </Col>
      </Row>
    </Container>
  </S.ContentWrapper>
)

export default ModalContentError
